import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        style={{
          minHeight: "50vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          textAlign: "center",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <h1 style={{ margin: "0 0 8px", fontSize: 22 }}>Что-то пошло не так</h1>
        <p style={{ margin: "0 0 20px", color: "#64748b", maxWidth: 360 }}>
          Произошла ошибка интерфейса. Обновите страницу или вернитесь на главную.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            border: "none",
            borderRadius: 12,
            padding: "12px 20px",
            background: "#7c3aed",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Обновить
        </button>
      </div>
    );
  }
}
